import request from '../utils/backend';
import env from '../environment';
import * as actions from '../constants/tashiActions';

const tashiActions = {

    loadVersion() {
        return dispatch => {
            request
                .get(env.tashi + '/version')
                .accept('text/plain')
                .end((err, res) => {
                    if (err) {
                        dispatch(actions.loadVersion({ status: "failure", data: err }));
                        return;
                    }

                    let version = res.text.split(" ")[1];

                    if (res.ok) {
                        dispatch(actions.loadVersion({ status: "success", data: version.substring(1) }));
                    } else {
                        dispatch(actions.loadVersion({ status: "failure", data: res.status }));
                    }
                });
        };
    },

    clearVersionError() {
        return dispatch => {
            dispatch(actions.clearVersionError());
        };

    }

};

export default tashiActions;



/** WEBPACK FOOTER **
 ** ./src/app/actions/tashiActionCreators.js
 **/